import "./SendToPanel.scss";

import { InlineSpinner } from "components/InlineSpinner";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { useSendToPanel } from "providers";
import { useTranslations } from "providers";
import React from "react";

import { SendToForm } from "./SendToForm";
import { SendToPanelFooter } from "./SendToPanelFooter";

export const SendToPanel: React.FC = () => {
  const i18n = useTranslations();
  const { isOpen, isLoading, isSubmitting, isSubmitted, isForm, closeSendToPanel, results } = useSendToPanel();

  // Return null if panel is closed
  if (!isOpen) {
    return null;
  }

  return (
    <SlidingPanel
      isOpen={true}
      size={35}
      onClose={closeSendToPanel}
      panelContainerClassName="sendto-panel"
      header={<h1 className="pb-3">{i18n.SendtoPanel_Header}</h1>}
      footer={<SendToPanelFooter />}
    >
      <>
        <p className="description">{i18n.SendtoPanel_Description}</p>

        {isLoading && <InlineSpinner text={i18n.SendtoPanel_Loading} />}
        {isForm && results && results.length > 0 && <SendToForm />}
        {isSubmitting && <InlineSpinner text={i18n.SendtoPanel_Submitting} />}
        {isSubmitted && <div>{i18n.SendtoPanel_Success}</div>}
      </>
    </SlidingPanel>
  );
};
